import React from 'react';

// Styles & Assets
import styles from './RowPharmacy.module.css';

// Services
import { sortArray } from '../../../services/sort';

// Hooks
import { useState } from 'react';

// Components
import AdherenceCells from '../AdherenceCells/AdherenceCells';
import DrugNameCell from '../DrugNameCell/DrugNameCell';

// Interfaces
import { AdministrationVia, DrugAdministrationList } from '../../../interfaces/Drug';

// Language
import { useTranslation } from 'react-i18next';

const RowPharmacy: React.FC<{
    children: React.ReactElement
    drug: DrugAdministrationList,
    optionalTable?: boolean,
}> = ({ children, drug, optionalTable }) => {

    const { t } = useTranslation();

    const hoursDose = Object.keys(drug.hours);

    const [showElements, setShowElements] = useState<boolean>(false);

    const handleClickDropdown = () => setShowElements(oldShow => !oldShow);

    const styleDropdown = !showElements && hoursDose.length > 1 ? { display: 'none' } : undefined;

    const getColorTextVia = (administrationVia: AdministrationVia | null) => {
        switch (administrationVia) {
        case 'inhaled': return '#21AB00';
        case 'intravenous': return '#BD1622';
        case 'oral':
        default: return '#000';
        }
    };

    return (
        <>
            {hoursDose.length > 1 &&
                <tr >
                    <DrugNameCell
                        drug={drug}
                        dropdownRow={{
                            showElements,
                            handleClickDropdown,
                        }}
                        optionalTable={optionalTable}
                    />
                    <td className={`pharmaCell blueCell ${styles.viaAdmin}`} style={{color: getColorTextVia(drug.administration_way)}}>{t(drug.administration_way || '')}</td>
                    {children}
                    <AdherenceCells
                        drug={drug}
                    />
                </tr>
            }
            {sortArray(hoursDose).map((hour) => {
                return (
                    <tr key={(drug.drugId?.toString() || '') + hour} style={styleDropdown}>
                        <DrugNameCell
                            drug={drug}
                            nonDropdownRow={{
                                hour,
                            }}
                            optionalTable={optionalTable}
                        />
                        <td className={`pharmaCell blueCell ${styles.viaAdmin}`} style={{color: getColorTextVia(drug.administration_way)}}>{t(drug.administration_way || '')}</td>
                        {React.cloneElement(children, { hour })}
                        <AdherenceCells
                            drug={drug}
                            hour={hour}
                        />
                    </tr>
                );
            })}
        </>
    );
};

export default RowPharmacy;